import React, { memo } from "react";
import Col from "component/layoutComponents/Col/Col";
import Row from "component/layoutComponents/Row/Row";
import ApprovalDetailsCard from "./ApprovalDetailsCard";
import OrderDetailsCard from "./OrderDetailsCard";
import { OrderDetails, UserMarketplace } from "../../types";

type Props = {
  userMarketplace: UserMarketplace;
  orderDetails: OrderDetails;
  onApprove: () => void;
  onDecline: () => void;
  setOpenEditOrderDetailCard: (isOpen: boolean) => void;
  requesterApprover?: string;
  isApprovalPage?: boolean;
  locale: any;
};

const InfoDetailsContent = ({
  orderDetails,
  onApprove,
  onDecline,
  setOpenEditOrderDetailCard,
  requesterApprover,
  isApprovalPage,
  locale,
}: Props) => {
  return (
    <Row>
      <Col xs={12} md={4} lg={12}>
        <ApprovalDetailsCard
          requesterApprover={requesterApprover}
          isApprovalPage={isApprovalPage}
          orderDetails={orderDetails}
          locale={locale}
        />
      </Col>
      <Col xs={12} md={8} lg={12}>
        <OrderDetailsCard
          onApprove={onApprove}
          onDecline={onDecline}
          orderDetails={orderDetails}
          setOpenEditOrderDetailCard={setOpenEditOrderDetailCard}
          isApprovalPage={isApprovalPage}
          locale={locale}
        />
      </Col>
    </Row>
  );
};

export default memo(InfoDetailsContent);
